/* counter js  */
function counter(){
	$('.stat-number').each(function () {

     var size = $(this).text().split(".")[1] ? $(this).text().split(".")[1].length : 0;

     $(this).prop('Counter', 0).animate({
        Counter: $(this).text().replaceAll(',','')
     }, {
        duration: 4000,
        step: function (func) {
           var num = (func).toFixed(size);
           num = num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
           $(this).text(num);
        }
     });
  });
}

// $(document).on('scroll', function() {
//   if ($(this).scrollTop() >= $('#projectFacts').position().top) {
//     console.log('I have been reached');
//   }
// })
$('.stat-number').each(function () {

   var size = $(this).text().split(".")[1] ? $(this).text().split(".")[1].length : 0;
   
   $(this).prop('Counter', 0).animate({
      Counter: $(this).text().replaceAll(',','')
   }, {
      duration: 4000,
      step: function (func) {
         var num = (func).toFixed(size);
         num = num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
         $(this).text(num);
      }
   });
});

$('.dropdown_container_toggle').css("display", "none");

$('.search_form a').click(function() {
    $('.dropdown_container_toggle').css("display", "block");
  });

$('.close_search').click(function() {
    $('.dropdown_container_toggle').css("display", "none");
});

// image-slider js
  $(document).ready(function(){
    var myInterval = setInterval(function() {
      if($('.image-slider').length > 0){
        clearInterval(myInterval);
          var imageSlider = $('.image-slider').slick({
            dots: false,
            infinite: true,
            speed: 300,
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            autoplay: true,
            autoplaySpeed: 7000
          });
          imageSlider.on('afterChange', function(event, slick, currentSlide){
            var currentEle = $('.image-slider .slick-active .left-text ul');
            var h = currentEle.innerHeight() + 'px'; console.log(h);
            //currentEle.css('height', h);
          });
      }
    },100);
});
